var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-wrap"},[_c('div',{ref:"layer1",staticClass:"star-layer layer1"}),_c('div',{ref:"layer2",staticClass:"star-layer layer2"}),_c('div',{ref:"layer3",staticClass:"star-layer layer3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }